document.addEventListener('DOMContentLoaded', function () {

  // アニメーションスピード
  const animeSpeed = 200;

  // form id name
  const form_id = '#formworks';

  // Rules
  const rules = {
    category: {
      required: true
    },
    date01: {
      required: true
    },
    lastName: {
      required: true
    },
    firstName: {
      required: true
    },
    lastNameKana: {
      required: true,
      kana: true
    },
    firstNameKana: {
      required: true,
      kana: true
    },
    gender: {
      required: true
    },
    year: {
      required: true
    },
    month: {
      required: true
    },
    day: {
      required: true
    },
    zip: {
      required: true
    },
    address: {
      required: true
    },
    locality: {
      required: true
    },
    tel: {
      required: true,
      tel: true,
      number: true
    },
    email: {
      required: true,
      mail: true
    },
    emailConfirm: {
      required: true,
      equalTo: '#email'
    },
    privacy: {
      required: true
    }
  } // rules

  const messages = {
    category: {
      required: '選択してください'
    },
    date01: {
      required: '入力してください'
    },
    lastName: {
      required: '入力してください'
    },
    firstName: {
      required: '入力してください'
    },
    lastNameKana: {
      required: '入力してください',
      kana: '全角カタカナで入力してください'
    },
    firstNameKana: {
      required: '入力してください',
      kana: '全角カタカナで入力してください'
    },
    gender: {
      required: '選択してください'
    },
    year: {
      required: '選択してください'
    },
    month: {
      required: '選択してください'
    },
    day: {
      required: '選択してください'
    },
    zip: {
      required: '入力してください'
    },
    address: {
      required: '入力してください'
    },
    locality: {
      required: '入力してください'
    },
    tel: {
      required: '入力してください',
      tel: '正しい番号を入力してください。（半角数字・ハイフン不要）',
      number: '正しい番号を入力してください。（半角数字・ハイフン不要）'
    },
    email: {
      required: '入力してください',
      mail: '正しいメールアドレスを入力してください'
    },
    emailConfirm: {
      required: '入力してください',
      equalTo: 'メールアドレスが違います'
    },
    privacy: {
      required: 'チェックしてください'
    }
  }

  // 追加ルールの定義
  const methods = {
    halfchara: function halfchara( value, element ){
      return this.optional(element) || /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
    },
    kana: function number( value, element ){
      return this.optional(element) || /^([ァ-ンヴー]+)$/.test(value);
    },
    tel: function tel( value, element ) {
      // 電話番号のバリデーション
      return this.optional(element) || /^\d{10,11}$/.test(value);
    },
    mail: function mail( value, element ) {
      // メールアドレスのバリデーション
      return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
    }
  }
  // メソッドの追加（上記の追加ルールを適用させる）
  $.each( methods, function( key ) {
    $.validator.addMethod( key, this );
  })

  // jQuery Validation Plugin の初期化
  $( form_id ).validate({
    rules    : rules,
    messages : messages,
    // フォーカスアウトでバリデーション
    onfocusout: function onfocusout( element ){
      if ( ! this.checkable( element ) ) {
        this.element( element );
      }
    },
    // エラーメッセージの表示位置
    errorPlacement: function errorPlacement( error, element ){
      // チェックボックス用に [] を取り除く
      const eleName = '#' + element.attr('name').replace( /\[\]/g, '' );
      if ( element.attr('name') == 'requestYear' || element.attr('name') == 'requestMonth' ) {
        error.prependTo('#requestDate_error');
      } else {
        error.prependTo( eleName + '_error' );
      }
    },
    // submit
    //submitHandler: function(form){
    //  const fd = $(form).serialize()
    //  confirmHandler( './ajax-comfirm-modal.php', fd, form )
    //}

  });

});
